import { inject, injectable } from "tsyringe";
import { Observable } from "rxjs";

import { autoBind } from "src/shared/decorators/autobind";
import { HttpClient } from "src/infra/http/client";
import { replaceString } from "src/libs/replace-string";

export interface VoucherDownloadParams {
    userIdentity: string;
    category: string;
    systemCode: string;
    policyId: string;
    couponId: string;
    voucherId: number;
}

@injectable()
export class VoucherDownloadRepository {
    public readonly ENDPOINT =
        "insureds/:userIdentity/insurances/all/policies/:policyId/coupons/:couponId/vouchers/:voucherId";

    constructor(@inject("HttpClient") private http: HttpClient) {}

    @autoBind
    download(params: VoucherDownloadParams): Observable<Record<string, any>> {
        const url = this.getDownloadUrl(params);
        const headers = {
            isPublicRequest: false,
            params: { "system-code": params.systemCode },
        };
        return this.http.get<object>(url, headers);
    }

    @autoBind
    private getDownloadUrl(params: VoucherDownloadParams): string {
        const terms = {
            ":userIdentity": params.userIdentity,
            ":category": params.category,
            ":policyId": params.policyId,
            ":couponId": params.couponId,
            ":voucherId": params.voucherId,
        };
        return replaceString(this.ENDPOINT, terms);
    }
}
